import { useEffect, useState } from "react";
import TraveledCard from "../../Components/TravelCard/TravelCard";
import TaskTable from "../../Components/TaskTable/TaskTable";
import History from "../../Components/History/History";
import CallHistoryComponent from "../../Components/CallHistory/CallHistoryComponent";
import AssignLeadComponent from "../../Components/AssignLeadComponent/AssignLeadComponent";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import AssetAssignedComponent from "../../Components/AssetAssignedComponent/AssetAssignedComponent";
import LeadTracker from "../../Components/LeadTracker/lead-traker";
// import { MapContainer, TileLayer, Polyline, Marker, Popup } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import img1 from "../../images/walletuser.png";
import img2 from "../../images/userdetails2.png";
import { useSelector } from "react-redux";
import {
  getActivityById,
  getAssetsEmployee,
  getEmployeestats,
  getLeadEmployee,
  getQuaterlySales,
  getTaskbyId,
  getTopClient,
  getTravelEmployee,
  toggleEmployeeActivation,
} from "../../Actions/actions";
import { useDispatch } from "react-redux";
import Loader from "../../Components/Loader/Loader";
import moment from "moment";

const UserDetails = () => {
  const dispatch = useDispatch();

  const {
    loginData,
    topClient,
    activityById,
    singleEmployee,
    taskData,
    loader,
    assetemp,
    leademp,
    taskemp,
    travelemp,
    empstats,
    quarterlysales,
  } = useSelector((state) => state.userReducer);

  const [selectedOption, setSelectedOption] = useState("");
  const [isEmployeeActive, setIsEmployeeActive] = useState(false);

  useEffect(() => {
    console.log({ singleEmployee });
    setIsEmployeeActive(singleEmployee?.isActive === 1 ? true : false);
    dispatch(getTaskbyId(loginData?.accessToken, singleEmployee.id));
    dispatch(getAssetsEmployee(loginData?.accessToken, singleEmployee.id));
    dispatch(getLeadEmployee(loginData?.accessToken, singleEmployee.id));
    dispatch(getTravelEmployee(loginData?.accessToken, singleEmployee.id));
    dispatch(getEmployeestats(loginData?.accessToken, singleEmployee.id));
    dispatch(getQuaterlySales(loginData?.accessToken, singleEmployee.id));
    dispatch(getTopClient(loginData?.accessToken, singleEmployee.id));
    dispatch(getActivityById(loginData?.accessToken, singleEmployee.clientId));
  }, [dispatch, loginData?.accessToken, singleEmployee, singleEmployee.id]);
  const [salesData, setsalesData] = useState([]);
  const [travelcardAdmin, settravelcardAdmin] = useState([]);

  useEffect(() => {
    let data = [
      { name: "Q1", revenue: quarterlysales?.Quarter1 },
      { name: "Q2", revenue: quarterlysales?.Quarter2 },
      { name: "Q3", revenue: quarterlysales?.Quarter3 },
      { name: "Q4", revenue: quarterlysales?.Quarter4 },
    ];
    setsalesData([...data]);
  }, [quarterlysales]);

  useEffect(() => {
    const data = [
      {
        label: "Total Lead Assigned",
        value: empstats?.totalLeadsAssigned,
        icon: <img src={img1} alt="Repotal Logo" className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
      },
      {
        label: "Conversion Rate",
        value: empstats?.conversionRate + "%",
        icon: <img src={img1} alt="Repotal Logo" className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
      },
      {
        label: "Revenue Generated",
        value: "AED " + empstats?.revenueGenerated,
        icon: <img src={img1} alt="Repotal Logo" className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
      },
      {
        label: "Leads Converted to Deals",
        value: empstats?.leadsConvertedToDeals,
        icon: <img src={img1} alt="Repotal Logo" className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
      },
      {
        label: "Tasks Completed",
        value: empstats?.tasksCompleted,
        icon: <img src={img1} alt="Repotal Logo" className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
      },
      {
        label: "Total Account",
        value: empstats?.totalAccount,
        icon: <img src={img1} alt="Repotal Logo" className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
      },
    ];
    settravelcardAdmin([...data]);
  }, [empstats]);

  const callData = [
    {
      name: "Test",
      purpose: "Other",
      duration: "10 minutes",
      time: "10:45 am",
      date: "Oct 23, 2024",
    },
    {
      name: "Test",
      purpose: "Other",
      duration: "10 minutes",
      time: "10:45 am",
      date: "Oct 23, 2024",
    },
    {
      name: "Test",
      purpose: "Other",
      duration: "10 minutes",
      time: "10:45 am",
      date: "Oct 23, 2024",
    },
    {
      name: "Test",
      purpose: "Other",
      duration: "10 minutes",
      time: "10:45 am",
      date: "Oct 23, 2024",
    },
  ];

  const dropdownOptions = [
    { label: "Last 7 Days", value: "7" },
    { label: "Last 15 Days", value: "15" },
    { label: "Last 30 Days", value: "30" },
  ];

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const formatDueDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const handleDownloadCSVAssets = () => {
    const csvData = [
      ["Resource Type", "Details", "Date Assigned"],
      ...assetemp.map((row) => [row.assetType, row.details, row.createdAt]),
    ];

    const csvString = csvData.map((row) => row.join(",")).join("\n");

    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", "asset_assigned.csv");
    a.click();
  };

  const handleDownloadCSVCall = () => {
    const csvData = [
      ["Lead Name", "Purpose Of Call", "Call Duration", "Time", "Date"],
      ...callData.map((row) => [row.name, row.purpose, row.duration, row.time, row.date]),
    ];

    const csvString = csvData.map((row) => row.join(",")).join("\n");

    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", "call_history.csv");
    a.click();
  };

  const handleDownloadCSV = () => {
    const csvData = [
      ["Purpose of Travel", "From", "To", "Distance Driven (km)", "Time Spent (mins)", "Date"],
      ...travelemp.map((item) => [
        item.purpose,
        item.startLocation,
        item.destination,
        item.distance + " km",
        item.duration + " mins",
        formatDueDate(item.scheduledDate),
      ]),
    ];

    const csvString = csvData.map((row) => row.join(",")).join("\n");

    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", "travel_history.csv");
    a.click();
  };

  const activitiesData = [
    {
      activity: "Closed a deal with ACME Corp. worth AED 15,000",
      date: "08 Apr 2022",
    },
    { activity: "Added a new lead: Jane Smith", date: "08 Apr 2022" },
    {
      activity: 'Moved lead "TechLead Solutions" to Proposal Stage',
      date: "08 Apr 2022",
    },
    {
      activity: "Completed Task: Follow-up with SmartTech Co.",
      date: "08 Apr 2022",
    },
  ];

  const travelDetails = [
    {
      location: "Dubai Marina",
      status: "Departed successfully.",
      time: "10:00 AM",
      coords: [25.0803, 55.1403],
    },
    {
      location: "Mall of the Emirates",
      status: "30 min stopover.",
      time: "10:30 AM",
      coords: [25.1186, 55.2004],
    },
    {
      location: "Business Bay",
      status: "In Progress",
      time: "In Progress",
      coords: [25.1855, 55.2486],
    },
    {
      location: "Dubai International Airport",
      status: "Pending",
      time: "Pending",
      coords: [25.2504, 55.3657],
    },
  ];

  const pathCoordinates = travelDetails.map((stop) => stop.coords);

  return (
    <ParentComponent>
      <PrimaryHeader />
      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="mt-6  bg-white rounded-xl p-4 shadow-lg flex justify-between items-center w-full ">
            <div className="flex sm:flex-col md:flex-row items-center space-x-4 sm:w-[33%] md:w-[67%]">
              {singleEmployee?.logo ? (
                <img src={singleEmployee?.logo} className="w-44 h-44 rounded-full object-cover" />
              ) : (
                <div className=" flex w-44 h-44 rounded-full bg-gray-400 items-center justify-center">
                  <p className="font-bold text-white text-6xl">{singleEmployee?.FullName?.slice(0, 1)}</p>
                </div>
              )}
              <div>
                <h2 className="text-xl font-semibold text-gray-800 sm:text-center md:text-left sm:mr-4 md:0 ">
                  {singleEmployee?.FullName}
                </h2>
                <p className="text-md text-gray-600 ">{singleEmployee?.Roles}</p>
                <p className="text-md text-blue-500 text-center">{singleEmployee?.email}</p>
              </div>
            </div>

            <div className="flex items-center space-x-4  md:w-[33%]">
              <div className="text-center sm:mr-[-20px] md:mr-[50px]">
                <p className="text-md text-black font-semibold">Joining Date</p>
                <p className="text-md text-gray-700">{moment(singleEmployee.createdAt).format("MMMM DD, YYYY")}</p>
              </div>
              <span
                className={`${
                  isEmployeeActive ? " bg-green-600" : "bg-red-600"
                }  text-white text-xs font-bold px-2 py-1 rounded-md cursor-pointer ${
                  isEmployeeActive ? "hover:bg-green-800" : "hover:bg-red-800"
                } transition`}
                onClick={() => {
                  dispatch(
                    toggleEmployeeActivation(singleEmployee?.id, loginData?.accessToken, (data) => {
                      setIsEmployeeActive(data?.data?.isActive);
                    })
                  );
                }}
              >
                {isEmployeeActive ? "Active" : "Deactivated"}
              </span>
            </div>
          </div>
          <div className="flex flex-wrap gap-4 my-6 justify-center">
            {travelcardAdmin?.map((metric, idx) => {
              return <TraveledCard metric={metric} idx={idx} userdetails />;
            })}
          </div>
          <TaskTable tasks={taskemp} need={false} heading={"Tasks"} />
          {/* {loginData?.clientData?.geolocationService &&
                        <div className="bg-gray-50 mt-6 rounded-xl shadow-lg flex flex-col">
                            <div className="w-full p-6  mb-4 flex flex-row justify-between items-center">
                                <h2 className="text-xl font-semibold">Live Location</h2>
                                <div className="flex items-center bg-green-700 text-white text-sm px-2 py-1 rounded-lg">
                                    Active
                                </div>
                            </div>




                            <div className="relative w-full mt-6 lg:mt-0 h-[500px] bg-white rounded-b-xl shadow-md">
                                <MapContainer
                        center={[25.0803, 55.1403]}
                        zoom={12}
                        scrollWheelZoom={false}
                        className="h-full w-full z-10" // Ensure the map is behind other elements
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution=""
                        />
                        <Polyline positions={pathCoordinates} color="black" weight={4} />
                        {travelDetails.map((stop, index) => (
                            <Marker key={index} position={stop.coords}>
                                <Popup>
                                    <div>
                                        <p className="font-medium">{stop.location}</p>
                                        <p className="text-sm text-gray-500">{stop.status}</p>
                                    </div>
                                </Popup>
                            </Marker>
                        ))}
                    </MapContainer>

                                <div className="min-w-[30%] p-4 bg-white rounded-lg shadow-md absolute sm:top-20 md:top-2 md:left-14 sm:left-2 z-50">
                                    <h2 className="text-md font-semibold mb-2">Current Travel Details</h2>
                                    <div className="flex">
                                        <div>
                                            <p className="text-xs text-gray-600">Purpose of Travel</p>
                                            <p className="text-sm font-medium">Presentation Delivery</p>
                                            <p className="text-xs text-gray-500">Dubai International Airport</p>
                                        </div>
                                        <div className="flex ml-10 justify-center items-center">
                                            <div className="bg-gray-100 rounded mr-5 pl-1.5 py-1.5">
                                                <IoCallOutline className="mr-2 text-gray-950" size={20} />
                                            </div>
                                            <div className="bg-gray-100 rounded mr-5 pl-1.5 py-1.5">
                                                <BsChatSquareText className="mr-2 text-gray-950" size={20} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex">
                                        <div className="w-[50%]">
                                            <p className="mt-4 text-xs font-semibold text-gray-500">Vehicle ID:</p>
                                            <span className="font-semibold text-xs">EV-2017002346</span>
                                        </div>
                                        <div className="my-2 flex justify-center">
                                            <img
                                                src={car}
                                                alt="Repotal Logo"
                                                className="w-[120px] h-auto ml-10"
                                            />
                                        </div>
                                    </div>
                                    <ul className="">
                                        {travelDetails.map((detail, index) => (
                                            <li key={index} className="mb-4 flex items-start">
                                                <div className="relative">
                                                    <div className={`w-3 h-3 ${detail.isCompleted ? 'bg-purple-600' : 'bg-gray-900'} rounded-full`}></div>
                                                    {index < travelDetails.length - 1 && (
                                                        <div className={`absolute left-1 top-3 w-0.5 ${detail.isCompleted ? 'bg-purple-600' : 'bg-gray-300'} h-12`}></div>
                                                    )}
                                                </div>
                                                <div className="ml-4">
                                                    <p className="font-medium text-sm flex items-center">
                                                        <MdLocationPin className="mr-2 text-gray-700" /> {detail.location}
                                                    </p>
                                                    <div>
                                                        <p className="text-xs text-gray-500 flex items-center">
                                                            {detail.isCompleted ? (
                                                                <FaPhoneAlt className="mr-2 text-purple-500" />
                                                            ) : (
                                                                <FaStopwatch className="mr-2 text-gray-500" />
                                                            )}
                                                            {detail.status}
                                                        </p>
                                                        <p className="text-sm text-gray-700 absolute right-5">{detail.time}</p>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>


                        </div>} */}
          <div className="mt-6"></div>
          <LeadTracker />
          <div className="mt-6"></div>
          <AssignLeadComponent viewall={true} need={false} heading={"Assigned Lead"} travelData={leademp} />
          <div className="bg-white p-4 rounded-lg shadow-lg mt-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Recent Activities</h2>
            <ul className="space-y-4 h-56 overflow-y-auto">
              {activityById?.length > 0
                ? activityById.map((item, index) => (
                    <li key={index} className="flex justify-between items-center border-b last:border-none pb-2">
                      <span className="text-gray-700 text-sm sm:w-9/12 md:w-8/12">{item.activity}</span>
                      <span className="text-gray-500 text-sm ">{moment(item.createdAt).format("DD-MMM-YYYY")}</span>
                    </li>
                  ))
                : "No Data Found"}
            </ul>
          </div>
          <div className="mt-6"></div>
          <AssetAssignedComponent
            viewall={true}
            need={true}
            heading={"Assets Assigned"}
            travelData={assetemp}
            handleDownloadCSV={handleDownloadCSVAssets}
            dropdownOptions={dropdownOptions}
            selectedOption={selectedOption}
            handleOptionChange={handleOptionChange}
          />
          <div className="mt-6"></div>
          <History
            viewall={true}
            need={true}
            heading={"Travel History"}
            travelData={travelemp}
            handleDownloadCSV={handleDownloadCSV}
            dropdownOptions={dropdownOptions}
            selectedOption={selectedOption}
            handleOptionChange={handleOptionChange}
          />
          {/* <div className="mt-6"></div>
          <CallHistoryComponent
            viewall={true}
            need={true}
            heading={"Call History"}
            travelData={callData}
            handleDownloadCSV={handleDownloadCSVCall}
            dropdownOptions={dropdownOptions}
            selectedOption={selectedOption}
            handleOptionChange={handleOptionChange}
          /> */}
          <div className="mt-6 flex flex-col lg:flex-row justify-between space-y-4 lg:space-y-0 lg:space-x-6 ">
            <div className="flex-1 bg-white p-4 rounded-lg shadow-md">
              <h2 className="text-lg font-semibold text-gray-800 mb-4">Sales Performance</h2>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart layout="vertical" data={salesData} margin={{ top: 20, right: 20, bottom: 20, left: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis type="number" />
                  <YAxis dataKey="name" type="category" />
                  <Tooltip />
                  <Bar dataKey="revenue" fill="#361D32" barSize={30} />
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="flex-1 bg-white rounded-lg shadow-md sm:mb-20 md:0">
              <h2 className="text-lg font-semibold text-gray-800  p-4 ">Top Clients Managed</h2>
              <div className="w-full ">
                <table className="min-w-full overflow-hidden">
                  <thead className="bg-gray-100">
                    <tr className="bg-gray-100 text-left">
                      <th className="x-4  p-4 text-left text-sm font-medium text-gray-600">Client Name</th>
                      {/* <th className="x-4 p-4text-left text-sm font-medium text-gray-600">Total Deals</th> */}
                      <th className="x-4 p-4 text-left text-sm font-medium text-gray-600">Revenue</th>
                    </tr>
                  </thead>
                  <tbody className="text-sm text-gray-800">
                    {topClient?.length > 0 ? (
                      topClient?.map((client, idx) => (
                        <tr key={idx} className="border-b last:border-none">
                          <td className="p-4 text-gray-800">{client.leadName}</td>
                          <td className="p-4 text-gray-800">AED {client.leadBudget}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center py-4 text-gray-500">
                          No client found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </ParentComponent>
  );
};

export default UserDetails;
